import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=659cf3be&scoped=true"
import script from "./TestimonialCard.js?vue&type=script&lang=js&external"
export * from "./TestimonialCard.js?vue&type=script&lang=js&external"
import style0 from "./TestimonialCard.scss?vue&type=style&index=0&id=659cf3be&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659cf3be",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Image/Image.vue').default,HcmAvatar: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/node_modules/@hotmart-org-ca/cosmos-mkt/components/Elements/HcmAvatar/index.vue').default,HcmCard: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/node_modules/@hotmart-org-ca/cosmos-mkt/components/Elements/HcmCard/index.vue').default})
